export default "__VITE_ASSET__C1O$RsBJ__"